module.exports = __webpack_public_path__ + "static/chemical-cover-20c9c6ad5d97bf7e126530ed9b1b2962.jpg";